/**
 * Sample demo data — deliberately messy, so every repair and inference
 * path is exercised on first load.
 */

/** A messy CSV export: whitespace, currency, mixed date formats, nulls, outliers. */
export const DEMO_CSV = `id, full_name ,email,signup_date,amount,is_active,website,user_id,notes
1,"Doe, John",john.doe@example.com,2024-01-15,"$1,250.00",yes,https://example.com/john,550e8400-e29b-41d4-a716-446655440000,early adopter
2,"  Smith, Jane  ",jane.smith@example.com,01/22/2024,$980.50,true,https://jane.smith.example.com,550e8400-e29b-41d4-a716-446655440001,N/A
3,Bob O'Neill,bob@example.com,2024/02/03,"€2,300.75",YES,https://example.com/bob,550e8400-e29b-41d4-a716-446655440002,needs review
4,Alice Müller,alice.mueller@example.com,15.03.2024,£750.25,no,https://example.com/alice,550e8400-e29b-41d4-a716-446655440003,""
5,Marco Rossi,marco@example.com,2024-04-01T09:30:00Z,"¥12,000",FALSE,https://example.com/marco,550e8400-e29b-41d4-a716-446655440004,converted from trial
6,Chen Wei,chen.wei@example.com,April 5 2024,"1,499.99",true,https://example.com/chen,not-a-uuid,-
7,Fatima Al-Sayed,fatima@example.com,2024-04-20,4200,no,https://example.com/fatima,550e8400-e29b-41d4-a716-446655440006,priority follow-up
8,John Doe,john.doe@example.com,2024-05-02,"$0.99",yes,not-a-url,550e8400-e29b-41d4-a716-446655440007,null
9,Oluwaseun Adeyemi,olu@example.com,2024-05-15T14:22:31Z,"$2,999.00",true,https://example.com/olu,550e8400-e29b-41d4-a716-446655440008,top spender
10,  legacy  ,legacy@example,1999-12-31,"N/A",undefined,,550e8400-e29b-41d4-a716-446655440009,flagged for cleanup
11,Zoë Chan,zoe.chan@example.com,2024-06-01,"$315.42",yes,https://example.com/zoe,550e8400-e29b-41d4-a716-446655440010,
12,Ahmed Hassan,ahmed@example.com,2024-06-15T08:05:00Z,"$88.10",true,https://example.com/ahmed,550e8400-e29b-41d4-a716-446655440011,NaN
13,Grace Hopper,grace@example.com,2024-07-04,"1,000,000",no,https://example.com/grace,550e8400-e29b-41d4-a716-446655440012,undefined
14,Yuki Tanaka,yuki@example.com,2024-07-19,"$45.60",yes,https://example.com/yuki,550e8400-e29b-41d4-a716-446655440013,high five 🖐️
15,Priya Sharma,priya@example.com,2024-08-01T23:59:60Z,"$9.99",yes,https://example.com/priya,550e8400-e29b-41d4-a716-446655440014,test row
`;

/** A messy JSON export: mixed scalar shapes and a nested object. */
export const DEMO_JSON = `[
  {
    "orderId": 1001,
    "customer": "Doe, John",
    "email": "john.doe@example.com",
    "placedAt": "2024-03-01T10:00:00Z",
    "total": "$1,299.99",
    "paid": true,
    "address": { "city": "Portland", "zip": "97201" },
    "status": "shipped"
  },
  {
    "orderId": 1002,
    "customer": "  Jane Smith  ",
    "email": "jane.smith@example.com",
    "placedAt": "03/05/2024",
    "total": "$89.50",
    "paid": false,
    "address": { "city": "Austin", "zip": "73301" },
    "status": "pending"
  },
  {
    "orderId": 1003,
    "customer": "Bob O'Neill",
    "email": "bob@example.com",
    "placedAt": "2024-03-10",
    "total": "N/A",
    "paid": true,
    "address": { "city": "Berlin", "zip": "10115" },
    "status": "shipped"
  },
  {
    "orderId": "1004",
    "customer": "Alice Müller",
    "email": "alice@example.com",
    "placedAt": "March 12, 2024",
    "total": "€2,050.00",
    "paid": "yes",
    "address": { "city": "Paris", "zip": "75001" },
    "status": null
  },
  {
    "orderId": 1005,
    "customer": "Marco Rossi",
    "email": "marco@example.com",
    "placedAt": "2024-03-15T12:30:00Z",
    "total": 450,
    "paid": false,
    "address": { "city": "Tokyo", "zip": "100-0001" },
    "status": "cancelled"
  }
]`;

/** A syntactically valid but semantically hostile NDJSON payload. */
export const DEMO_NDJSON = `{"id":1,"payload":"' OR 1=1 --","ts":"1970-01-01T00:00:00Z"}
{"id":2,"payload":"<script>alert(1)</script>","ts":"2038-01-19T03:14:07Z"}
{"id":3,"payload":"👨‍👩‍👧‍👦","ts":"2024-02-29"}
{"id":4,"payload":"مرحبا بالعالم","ts":null}
{"id":5,"payload":"NaN","ts":"9999-12-31T23:59:59Z"}`;
